import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { blue } from "./constants";


const Job: React.FC<{
    title: string,
    company: string,
    url: string,
    start: number,
    end?: number,
    protocol?: string,
    accomplishments?: string[],
    last?: boolean,
}> = ({ title, company, url, start, end, protocol = 'http', accomplishments = [], last = false }) => {

    return (
        <Box
            sx={{
                fontSize: '0.9em',
                borderLeft: '2px solid #aaa',
                pl: 2,
                pb: last ? 0 : 1,
                position: 'relative',
            }}
        >
            <span
                style={{
                    position: 'absolute',
                    top: 0,
                    left: '-6px',
                    background: '#fff',
                    lineHeight: '0.4em',
                    fontSize: '1.4em',
                    fontWeight: 'bold',
                }}>
                &#9900;
            </span>
            <p style={{ margin: 0, lineHeight: '1em' }}>{start} - {end ? end : 'current'}</p>
            <p style={{ margin: 0 }}>
                {company} - {<a href={`${protocol}://${url}`} style={{ color: blue }}>{`${protocol}://${url}`}</a>}
            </p>
            <h4 style={{ margin: 0, marginTop: '5px', marginBottom: '5px' }}>{title}</h4>
            <ul
                style={{
                    listStylePosition: 'inside',
                    padding: 0,
                    margin: 0,
                }}
            >
                {accomplishments.map((acc, index) => <li key={index}>{acc}</li>)}
            </ul>
        </Box>
    )
}

export { Job };